import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CustomTable from "../../common/CustomTable";
import { useSelector, useDispatch } from "react-redux";
import { replaceUrlParam } from "../../common/utils";

import {
  fetchInvoiceByID,
  fetchInvoices,
  selectInvoices,
  setInvoice,
  setViewing,
  fetchMoreInvoices,
  getFullList,
} from "./invoicesSlice";
import Grid from "@material-ui/core/Grid";
import { fetchClients, selectClients } from "../clients/clientsSlice";
// import {fetchOrderUserByID} from '../users/usersSlice';

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
  root: {
    display: "flex",
    flexFlow: "column",
  },
}));

export default function InvoicesContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const classes = useStyles();
  const [invoiceNames, setInvoiceNames] = useState([]);
  const [userIDs, setUserIDs] = useState([]);
  // const edit = props.location.pathname.includes("edit");
  const { invoices, error, loading, invoicesList, lastQuery, invoicesAmount } =
    useSelector(selectInvoices);
  const { clients, clientsList } = useSelector(selectClients);

  const [numberShown, setNumberShown] = useState(10);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const rowsPerPageOptions = [5, 10, 25];

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [dateBefore, setDateBefore] = useState("");
  const [dateAfter, setDateAfter] = useState("");
  const [client, setClient] = useState("");
  const [searchTerm, setSearchTerm] = useState([]);

  const urlParams = new URLSearchParams(window.location.search);

  const invoiceParam = urlParams.get("invoice");
  // const clientParam = urlParams.get('client');

  useEffect(() => {
    if (invoiceParam) {
      dispatch(
        fetchInvoiceByID({
          token: jwtToken,
          invoiceID: invoiceParam,
          // query: `invoices=${invoiceParam != null ? invoiceParam : ""}&sort=desc`,
        })
      );
    }
  }, [invoiceParam]);

  useEffect(() => {
    if (client) {
      let searchQuery = lastQuery ? lastQuery : "";

      if (rowsPerPage) {
        searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
      }

      dispatch(
        fetchInvoices({
          token: jwtToken,
          query: searchQuery,
        })
      );

      setNumberShown(rowsPerPage);
    }
  }, [rowsPerPage]);

  const handleChange = (event) => {
    setClient(event.target.value);
    let searchQuery = `?limit=${rowsPerPage}`;

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }

    if (invoiceParam) {
      searchQuery = replaceUrlParam(searchQuery, "invoiceid", rowsPerPage);
    }

    searchQuery = replaceUrlParam(searchQuery, "clients", event.target.value);

    searchQuery = replaceUrlParam(searchQuery, "order_by", "created_at");

    searchQuery = replaceUrlParam(searchQuery, "sort", "desc");

    dispatch(
      fetchInvoices({
        token: jwtToken,
        query: searchQuery,
      })
    );
    setSortDirection("desc");
    setSortProperty("created_at");

    setNumberShown(rowsPerPage);
  };

  useEffect(() => {
    dispatch(fetchClients({ token: jwtToken, query: "" }));
  }, []);

  const headCells = [
    {
      id: "id",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Invoice #",
      long: false,
      sortable: true,
    },
    {
      id: "clientID",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Client ID",
      long: false,
      sortable: true,
    },
    {
      id: "xeroDetails",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Xero Invoice No.",
      long: false,
      object: true,
      objectProperty: "Invoices",
      nestedObject: true,
      nestedObjectProperty: "InvoiceNumber",
    },
    {
      id: "createdAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Invoice Date",
      long: false,
      sortable: true,
    },
    {
      id: "updatedAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Last Update",
      long: false,
      sortable: true,
    },
    {
      id: "ordersByInvoice",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "View Related Orders",
      long: false,
    },
    {
      id: "purchaseOrdersByInvoice",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "View Related Purchase Orders",
      long: false,
    },
  ];

  const [ready, setReady] = useState(false);
  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  const handleEdit = (id) => {};

  const handleEditClick = (id) => {
    const selectedInvoice = invoicesList.filter((invoice) => invoice.id === id);
    dispatch(setInvoice(selectedInvoice[0]));
    dispatch(
      fetchInvoiceByID({
        invoiceID: selectedInvoice[0].id,
        // clientID: selectedInvoice[0].clientID,
        token: jwtToken,
      })
    );
    // dispatch(setViewing(true));
  };

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 25);

    dispatch(
      getFullList({
        token: jwtToken,
        offset:
          rowsPerPage > invoicesList.length ? rowsPerPage : invoicesList.length,
        query: searchQuery,
        targetLength: invoicesAmount,
      })
    );
  };

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (
        invoicesList.length < invoicesAmount &&
        invoicesList.length < expectedLen
      ) {
        dispatch(
          fetchMoreInvoices({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
          })
        );
      } else if (invoicesList.length == invoicesAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
      case "totalPoints":
        property = "total_points";
        break;
      case "clientID":
        property = "client_id";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchInvoices({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  const handleSearch = () => {
    let daterange = "";
    if (dateBefore && dateAfter) {
      daterange = `${dateAfter.toISOString().substring(0, 10)},${dateBefore
        .toISOString()
        .substring(0, 10)}`;
    } else if (dateBefore && !dateAfter) {
      daterange = `lte,${dateBefore.toISOString().substring(0, 10)}`;
    } else if (!dateBefore && dateAfter) {
      daterange = `gte,${dateAfter.toISOString().substring(0, 10)}`;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (daterange) {
      searchQuery = replaceUrlParam(searchQuery, "udate", daterange);
    }
    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "name", searchTerm);
    }
    if (client) {
      searchQuery = replaceUrlParam(searchQuery, "clients", client);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchInvoices({
        query: searchQuery,
        token: jwtToken,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setDateAfter("");
    setDateBefore("");
    setClient("");
    setSearchTerm("");
    setSortDirection(null);
    setSortProperty(null);

    dispatch(
      fetchInvoices({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
      })
    );
    setCurrentPage(0);
  };

  const selectNames = ["status"];

  const [rowList, setRowList] = useState([...headCells]);

  const cellList = headCells.map((cell) => {
    return cell.id;
  });

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded" || loading === "idle") {
    content = (
      <CustomTable
        data={invoicesList}
        actionsLists={[]}
        actionsHandleChange={[]}
        actionsNames={[]}
        headCells={headCells}
        cellList={cellList}
        // handleEditClick={handleEditClick}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEdit={handleEdit}
        area={"invoice"}
        selectNames={selectNames}
        setSearchTerm={setSearchTerm}
        setDateBefore={setDateBefore}
        setDateAfter={setDateAfter}
        dateAfter={dateAfter}
        dateBefore={dateBefore}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        fetchInvoices={fetchInvoices}
        jwtToken={jwtToken}
        clientProp={client}
        // handleInvoiceClientChange={handleInvoiceClientChange}
        productsAmount={invoicesAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
        rowsPerPageOptions={rowsPerPageOptions}
      />
    );
  }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      <Grid
        item
        sm
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: 32,
          paddingRight: 32,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              marginRight: 24,
              padding: 0,
              marginLleft: 12,
              fontSize: 24,
              fontWeight: "bold",
              color: "#42494E",
              marginBottom: 0,
              marginTop: 4,
            }}
          >
            Select Client:
          </div>

          <div>
            <FormControl
              style={{ width: 250 }}
              margin="dense"
              className={classes.formControl}
            >
              <Select
                variant="outlined"
                value={client}
                margin="dense"
                onChange={handleChange}
                inputProps={{
                  name: "client",
                  id: "client-simple",
                }}
              >
                {clientsList.map((client) => (
                  <MenuItem key={client.id} value={client.id}>
                    {client.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        {/* <div onClick={handleProcessPurchaseOrders}>
          <ColorButton key={client.id} disabled={!client}>
            Process PurchaseOrders
          </ColorButton>
        </div> */}
      </Grid>

      {content}
    </Grid>
  );
}
